<div class="hero-page">
  <!-- Fullscreen Video Intro -->
  @if (showVideoIntro) {
    <div class="video-intro-overlay">
      <button class="continue-btn-floating" type="button" (click)="closeVideo()">
        Continue to Site &rarr;
      </button>

      @if (isMuted) {
        <button class="mute-toggle-btn" type="button" (click)="toggleMute()" aria-label="Unmute video">
          UNMUTE
        </button>
      }

      <!-- YouTube IFrame API replaces this div with the player iframe -->
      <div id="maintenance-yt-player" class="fullscreen-video-iframe"></div>

      <!--
        Blocks YouTube's native play/pause UI. Clicks here start/resume
        playback with sound via the API instead of toggling YouTube controls.
      -->
      <div
        class="video-click-shield"
        (click)="onOverlayClick($event)"
        aria-hidden="true"></div>
    </div>
  }

  <div class="hero-topbar">
    <img src="assets/imgs/Zumeralogo-WHITE.png" alt="Zumera Logo" class="hero-topbar__logo" />
  </div>

  <section class="hero-banner">
    <div class="overlay"></div>

    <div class="hero-banner__content">
      <p class="hero-banner__subtitle">Our website is under maintenance. We will be back soon.</p>

      <h1 class="hero-banner__title">
        <span class="dim">We Are Revealing Africa's </span><span class="bright">Power, Freedom and Beauty</span><span class="dim"> To The World Through A New Standard of Peerless Hospitality.</span>
      </h1>

      <div class="hero-banner__actions">
        <a routerLink="/benin-city" class="hero-btn">LEARN MORE</a>
        <a routerLink="/executive-jobs" class="hero-btn">CAREERS</a>
      </div>
    </div>
  </section>

  <app-figma-benin-footer></app-figma-benin-footer>
</div>
